var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BasePieChart"},[_c('div',{ref:"PieChart",staticStyle:{"width":"100%","height":"230px","overflow":"hidden"}}),_c('div',{staticClass:"flex justify-around text-xs m-1"},_vm._l((_vm.data),function(item,index){return _c('p',{key:index,staticClass:"mx-2 text center"},[_vm._v(_vm._s(item.value)+"%")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }